/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Code_ResentInputs */

const en_us2_auth_code_resent = /** @type {(inputs: Auth_Code_ResentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New code on its way. Use the latest one.`)
};

const pt_br2_auth_code_resent = /** @type {(inputs: Auth_Code_ResentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código novo a caminho. Use o mais recente.`)
};

const es_419_auth_code_resent = /** @type {(inputs: Auth_Code_ResentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código nuevo en camino. Usa el más reciente.`)
};

const pt_pt2_auth_code_resent = /** @type {(inputs: Auth_Code_ResentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código novo a caminho. Usa o mais recente.`)
};

const fr_fr2_auth_code_resent = /** @type {(inputs: Auth_Code_ResentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau code en route. Utilise le plus récent.`)
};

const de_de2_auth_code_resent = /** @type {(inputs: Auth_Code_ResentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer Code ist unterwegs. Nimm den neuesten.`)
};

const it_it2_auth_code_resent = /** @type {(inputs: Auth_Code_ResentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo codice in arrivo. Usa l'ultimo.`)
};

/**
* | output |
* | --- |
* | "New code on its way. Use the latest one." |
*
* @param {Auth_Code_ResentInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const auth_code_resent = /** @type {((inputs?: Auth_Code_ResentInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Code_ResentInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_auth_code_resent(inputs)
	if (locale === "es-419") return es_419_auth_code_resent(inputs)
	if (locale === "pt-PT") return pt_pt2_auth_code_resent(inputs)
	if (locale === "fr-FR") return fr_fr2_auth_code_resent(inputs)
	if (locale === "de-DE") return de_de2_auth_code_resent(inputs)
	if (locale === "it-IT") return it_it2_auth_code_resent(inputs)
	return en_us2_auth_code_resent(inputs)
});
export { auth_code_resent as "auth.code_resent" }